import { Card, CardContent, CardHeader, LoadingButton } from "@bvhi/ui-base";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDownload } from "../../../../../../hooks/use-download";
import { useAuthContext } from "../../../../../../context/use-auth-context";
import { APIError } from "@bvhi/backend-api/api-error";
import { getAppConfig } from "../../../../../../config/config";
import { DownloadIcon } from "@bvhi/ui-icons";

export const DownloadConnectedAudiologistsCard = () => {
  const { currentUser } = useAuthContext();
  if (!currentUser) {
    throw new APIError("CurrentUser has no organisation.", {
      status: 401,
      code: "UNAUTHORIZED",
      message: "CurrentUser does not exist.",
      timestamp: new Date().toISOString(),
    });
  }
  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const { t } = useTranslation(["users", "toasts"]);
  const { fetchFileAndDownload } = useDownload();

  const downloadConnectedAudiologists = useCallback(() => {
    void (async () => {
      if (!currentUser.organisation?.id) return;
      setIsDownloading(true);
      try {
        await fetchFileAndDownload(
          `${getAppConfig().env.baseUrl}/gateway/platform/v1/suppliers/${currentUser.organisation.id}/audiologists/download`
        );
      } catch (error) {
        console.error("Download failed:", error);
      } finally {
        setIsDownloading(false);
      }
    })();
  }, [currentUser.organisation?.id, fetchFileAndDownload]);

  return (
    <Card>
      <CardHeader subheader={t("users:audiologists.download.card.sub.title")} title={t("users:audiologists.download.card.title")} />
      <CardContent>
        <LoadingButton loading={isDownloading} onClick={downloadConnectedAudiologists} startIcon={<DownloadIcon />}>
          {t("users:users.card.marketing-consent.button")}
        </LoadingButton>
      </CardContent>
    </Card>
  );
};
